
import {
	Model,
	IModelAttributes,
	attribute,
	entity,
} from 'Models/Model';
import * as Models from 'Models/Entities';
import { IAcl } from '../Security/IAcl';
import { observable } from 'mobx';
import UserBusinessentitypaymentmethodmanytomany from '../Security/Acl/UserBusinessentitypaymentmethodmanytomany';
import VisitorsBusinessentitypaymentmethodmanytomany from '../Security/Acl/VisitorsBusinessentitypaymentmethodmanytomany';


export interface IBusinessEntityPaymentMethodAttributes extends IModelAttributes {
	businessEntityId: string;
	paymentMethodId: string;

	businessEntity: Models.BusinessEntity | Models.IBusinessEntityAttributes;
	paymentMethod: Models.PaymentMethodEntity | Models.IPaymentMethodEntityAttributes;

}

@entity('BusinessEntityPaymentMethod')
export default class BusinessEntityPaymentMethod
	extends Model
	implements IBusinessEntityPaymentMethodAttributes {
	public static acls: IAcl[] = [
		new UserBusinessentitypaymentmethodmanytomany(),
		new VisitorsBusinessentitypaymentmethodmanytomany(),

	];

	@observable
	@attribute()
	public businessEntityId: string;

	@observable
	@attribute()
	public paymentMethodId: string;

	@observable
	@attribute({ isReference: true })
	public businessEntity: Models.BusinessEntity;

	@observable
	@attribute({ isReference: true })
	public paymentMethod: Models.PaymentMethodEntity;


	constructor(attributes?: Partial<IBusinessEntityPaymentMethodAttributes>) {

		super(attributes);

		if (attributes) {
			if (attributes.businessEntityId) {
				this.businessEntityId = attributes.businessEntityId;
			}
			if (attributes.paymentMethodId) {
				this.paymentMethodId = attributes.paymentMethodId;
			}

			if (attributes.businessEntity) {
				if (attributes.businessEntity instanceof Models.BusinessEntity) {
					this.businessEntity = attributes.businessEntity;
					this.businessEntityId = attributes.businessEntity.id;
				} else {
					this.businessEntity = new Models.BusinessEntity(attributes.businessEntity);
					this.businessEntityId = this.businessEntity.id;
				}
			} else if (attributes.businessEntityId !== undefined) {
				this.businessEntityId = attributes.businessEntityId;
			}

			if (attributes.paymentMethod) {
				if (attributes.paymentMethod instanceof Models.PaymentMethodEntity) {
					this.paymentMethod = attributes.paymentMethod;
					this.paymentMethodId = attributes.paymentMethod.id;
				} else {
					this.paymentMethod = new Models.PaymentMethodEntity(attributes.paymentMethod);
					this.paymentMethodId = this.paymentMethod.id;
				}
			} else if (attributes.paymentMethodId !== undefined) {
				this.paymentMethodId = attributes.paymentMethodId;
			}
		}

	}


}
